export enum CustomSettingKey {
	CALENDAR_SETTINGS = 'calendar_settings',
	CALENDAR_NOTIFICATIONS_SETTINGS = 'calendar_notifications_settings',
	ALL_WORKPLACES_CALENDAR_SETTINGS = 'all_workplaces_calendar_settings',
	ONLINE_ORDERING_CALENDAR_SETTINGS = 'online_ordering_calendar_settings',
	SHIFTS_CALENDAR_SETTINGS = 'shifts_calendar_settings',
	CALENDAR_EVENT_CREATE_DEFAULT_DATA = 'calendar_event_create_default_data',
	MONITORING_CENTER_ALL_REQUESTS = 'monitoring_center_all_requests',
	MONITORING_CENTER_NEW_REQUESTS = 'monitoring_center_new_requests',
	MONITORING_CENTER_SOLVED_REQUESTS = 'monitoring_center_solved_requests',
	CASE_TYPES = 'insurance_companies_case_types',
	CARE_CLAIMS = 'insurance_companies_care_claims',
	MEDICAL_PROCEDURES_IMPORT = 'medical_procedures_import',
	INSURANCE_COMPANIES_BATCHES = 'insurance_companies_batches',
	CSSZ_SICK_LEAVE_SUBMISSIONS_OVERVIEW = 'cssz_sick_leave_submissions_overview',
	MANAGER_WORKPLACE_SICK_LEAVES = 'manager_workplace_sick_leaves',
}
